// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {getCsrfToken, getProviders, signIn, useSession} from "next-auth/react"
import {PageHead} from "../../core-web/components/core/templates/PageHead";
import {AppLayout} from "../../core-web/components/core/templates/AppLayout";
import {useRouter} from "next/router";
import {LANDING_META} from "../../core-web/constants";
import {Box, Button, Heading, Image, Text, Flex, Input} from "@chakra-ui/react";
import Footer from "../../core-web/components/landing/molecules/Footer";
import {useEffect} from "react";
import Sentry from "@sentry/nextjs";


export default function SignIn({providers, csrfToken}) {
  const {data: session} = useSession()
  const router = useRouter()
  const {error} = router.query
  const redirectTo: string = router.query['callbackUrl'] as string || "/app/home"
  if (session?.user) {
    router.push(redirectTo)
  }

  const providersList = Object.values(providers ?? {}) ?? []
  const emailProvider = providersList.find((p) => p.id === "email")
  const googleProvider = providersList.find((p) => p.id === "google")

  const widths = ["100%", 350]

  useEffect(() => {
    if (error) {
      if(Sentry && Sentry.captureEvent) {
        Sentry.captureEvent({
          message: "[Sign in] Captured new error",
          extra: {
            error: error,
            user: session?.user?.email
          }
        })
      }else {
        console.error("Cannot log error - no Sentry", error)
      }
    }
  }, [error])

  return (
    <PageHead title={"Sign in | NotionSender"} description={LANDING_META}>
      <AppLayout className={""}>
        <Flex direction={"column"}>
          <Box minH={"80vh"} display={"flex"} alignItems={"start"} justifyContent={"center"}>
            <Flex direction={"column"} alignItems={"center"} paddingTop={16}>
              <Heading fontWeight={"semibold"} textAlign={"center"}>Log in to your account</Heading>
              <Text size={"sm"} mt={2} color={"gray.500"} textAlign={"center"}>If you do not have the account - new
                account will be
                created.</Text>

              {error && <Text mt={2} color={"red.500"}>Error happened: {error}</Text>}
              {emailProvider && <Flex justifyContent={"center"} minW={widths} mt={8}>
                <form method="post" action="/api/auth/signin/email" className={"flex flex-col w-full"}>
                  <Input name="csrfToken" type="hidden" defaultValue={csrfToken}/>
                  <Input type="hidden" name="callbackUrl" value="/auth/signin"/>
                  <label>
                    <Text mb='8px'>Email address</Text>
                    <Input bgColor='gray.50' type="email" id="email" name="email"/>
                  </label>
                  <Button my={4}
                    isLoading={!!session?.user}
                    type="submit"
                    colorScheme={"blue"}
                    // backgroundColor={"#5383ec"}
                  >
                    <span>Sign in with Email</span>
                  </Button>
                </form>
              </Flex>}

              {googleProvider && <Box my={4} h={0.25} w="full" bgColor={"gray.300"}></Box>}
              {googleProvider && (
                <Flex direction={"column"} alignItems={"center"} minW={widths}>
                  <Button
                    colorScheme={"blue"}
                    w={"full"}
                    isLoading={!!session?.user}
                    // backgroundColor={"#5383ec"}
                    p={0} onClick={() => signIn(googleProvider.id, {})}>
                    <Box overflow={"hidden"} position={"absolute"} left={0} rounded={"xl"}>
                      <Image src={"/icons/google.svg"}
                        height={10}
                        width={10}
                      />
                    </Box>
                    <Text mx={2}> Sign in with {googleProvider.name} </Text>
                  </Button>
                </Flex>
              )}

            </Flex>

          </Box>
          <Footer/>
        </Flex>

      </AppLayout>

    </PageHead>
  )
}

export async function getServerSideProps(context) {
  const providers = await getProviders()
  const csrfToken = await getCsrfToken(context)
  return {
    props: {providers, csrfToken},
  }
}
